var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIntroToComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cecvzudd9a",
    d: "M0 441.12L466.726 441.12 466.726 0 0 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.5 58)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M44.5 17C29.336 17 17 29.336 17 44.5v283.741c0 15.163 12.336 27.5 27.5 27.5h377.726c15.164 0 27.5-12.337 27.5-27.5V44.501c0-15.165-12.336-27.5-27.5-27.5H44.5zm377.726 355.741H44.5c-24.538 0-44.5-19.963-44.5-44.5V44.501C0 19.961 19.962 0 44.5 0h377.726c24.538 0 44.5 19.961 44.5 44.5v283.74c0 24.537-19.962 44.5-44.5 44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M41.333 250.683h384.061V49.774c0-4.687-3.813-8.5-8.5-8.5H49.833c-4.687 0-8.5 3.813-8.5 8.5v200.909zm391.561 15H33.833c-4.142 0-7.5-3.358-7.5-7.5V49.774c0-12.958 10.542-23.5 23.5-23.5h367.061c12.958 0 23.5 10.542 23.5 23.5v208.409c0 4.142-3.358 7.5-7.5 7.5z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "wqbmaer8bb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cecvzudd9a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M8.5 292.016L458.226 292.016 458.226 275.016 8.5 275.016zM249.03 325.303c0-9.177-7.439-16.617-16.617-16.617-9.177 0-16.617 7.44-16.617 16.617s7.44 16.617 16.617 16.617c9.178 0 16.617-7.44 16.617-16.617M148.581 440.852l-4.233-16.465c22.605-5.812 32.585-46.166 34.523-61.224l16.863 2.148c-.34 2.677-8.765 65.67-47.153 75.541M316.246 440.852c-38.387-9.87-46.813-72.864-47.153-75.54l16.864-2.142-8.432 1.071 8.432-1.078c1.937 15.058 11.917 55.412 34.522 61.224l-4.233 16.465z",
    mask: "url(#wqbmaer8bb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M383.892 441.12H81.884c-4.694 0-8.5-3.806-8.5-8.5s3.806-8.5 8.5-8.5h302.008c4.694 0 8.5 3.806 8.5 8.5s-3.806 8.5-8.5 8.5",
    mask: "url(#wqbmaer8bb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDC5FF",
    d: "M290.522 59.278H181.141c-9.43-.01-17.081 7.746-17.091 17.322v122.224c4.805-4.913 11.349-7.664 18.168-7.637h118.559V69.692c0-5.752-4.591-10.414-10.255-10.414",
    mask: "url(#wqbmaer8bb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDC5FF",
    d: "M164.05 215.486c.318 9.878 8.44 17.637 18.167 17.356H293.94c3.771-.01 6.825-3.113 6.837-6.942v-6.943H191.395c-1.887 0-3.418-1.554-3.418-3.47 0-1.918 1.531-3.472 3.418-3.472h109.382V198.13h-118.56c-9.73-.289-17.856 7.474-18.167 17.356",
    mask: "url(#wqbmaer8bb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M257.082 150.11h-49.338c-3.452 0-6.251-2.8-6.251-6.251 0-3.453 2.799-6.252 6.251-6.252h49.338c3.454 0 6.252 2.799 6.252 6.252 0 3.452-2.798 6.25-6.252 6.25M203.956 95.737c-1.26 0-2.286 1.025-2.286 2.286v11.383c0 1.26 1.026 2.286 2.286 2.286h56.916c1.26 0 2.286-1.025 2.286-2.286V98.023c0-1.261-1.026-2.286-2.286-2.286h-56.916zm56.916 28.458h-56.916c-8.154 0-14.79-6.634-14.79-14.79V98.024c0-8.155 6.636-14.79 14.79-14.79h56.916c8.154 0 14.789 6.635 14.789 14.79v11.383c0 8.155-6.635 14.789-14.79 14.789z",
    mask: "url(#wqbmaer8bb)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntroToComputer);
export default __webpack_public_path__ + "static/media/icon--intro-to-computer.95a3751586c3a5cef426831d95bcbcfc.svg";
export { ForwardRef as ReactComponent };